export function ApiTrigger() {
  return (
    <>
      <div>
        <h2 className="text-header-2 mb-5">Your goal is triggered when someone:</h2>
      </div>
    </>
  );
}
